import React, { useState, useRef } from 'react';
import './otpInput.css'; // Import CSS file for styling

interface IProps {
  otp: string[];
  setOtp: React.Dispatch<React.SetStateAction<string[]>>;
}
const OtpInput = ({ otp, setOtp }: IProps) => {
  const inputRefs = useRef<HTMLDivElement[]>(Array(6).fill(null));

  const handleChange = (index: number, value: string) => {
    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      inputRefs.current[index].textContent = value;

      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    } else {
      inputRefs.current[index].textContent = '';
    }
  };

  const handleBackspace = (index: number, e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Backspace' && index > 0 && !otp[index]) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === 'Backspace' && otp[index]) {
      inputRefs.current[index].textContent = '';
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
    }
  };

  return (
    <div className='otp-container gap-[6px] md:gap-[10px]'>
      {otp.map((digit, index) => (
        <div
          key={index}
          className='otp-digit'
          tabIndex={0}
          contentEditable
          suppressContentEditableWarning
          ref={(el) => (inputRefs.current[index] = el!)}
          onKeyDown={(e) => handleBackspace(index, e)}
          onInput={(e) => handleChange(index, e.currentTarget.textContent || '')}
          inputMode='numeric'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {digit}
        </div>
      ))}
    </div>
  );
};

export default OtpInput;
